(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHeader = (root) => {
      if (!root || root.dataset.tlReady === 'true') return;
      root.dataset.tlReady = 'true';

      const drawer = root.querySelector('[data-tl-menu]');
      const openButton = root.querySelector('[data-tl-menu-toggle]');
      const closeButton = root.querySelector('[data-tl-menu-close]');
      const drawerLinks = root.querySelectorAll('[data-tl-menu-link]');
      const overlay = root.dataset.overlay === 'true';
      let lastY = window.scrollY;

      const setMenu = (open) => {
        if (!drawer || !openButton) return;
        drawer.hidden = !open;
        openButton.setAttribute('aria-expanded', String(open));
        document.documentElement.style.overflow = open ? 'hidden' : '';
        if (open) closeButton?.focus();
      };

      const updateHeader = () => {
        const y = window.scrollY;
        const hero = document.querySelector('[data-tl-hero]');
        const overHero = overlay && hero && hero.getBoundingClientRect().bottom > root.offsetHeight;
        root.classList.toggle('is-solid', !overHero);

        const movingDown = y > lastY + 4;
        const movingUp = y < lastY - 4;
        if (!overHero && movingDown && y > 180) root.classList.add('is-hidden');
        if (movingUp || overHero || y < 40) root.classList.remove('is-hidden');
        lastY = y;
      };

      openButton?.addEventListener('click', () => setMenu(true));
      closeButton?.addEventListener('click', () => setMenu(false));
      drawerLinks.forEach((link) => link.addEventListener('click', () => setMenu(false)));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && drawer && !drawer.hidden) setMenu(false);
      });
      window.addEventListener('scroll', updateHeader, { passive: true });
      updateHeader();

      root.tlCleanup = () => {
        window.removeEventListener('scroll', updateHeader);
        document.documentElement.style.overflow = '';
      };
    };

    document.querySelectorAll('[data-tl-header]').forEach(initHeader);
    document.addEventListener('shopify:section:load', (event) => initHeader(event.target.querySelector('[data-tl-header]')));
    document.addEventListener('shopify:section:unload', (event) => event.target.querySelector('[data-tl-header]')?.tlCleanup?.());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joya_homepage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHome = (root) => {
      if (!root || root.dataset.tlReady === 'true') return;
      root.dataset.tlReady = 'true';

      const hero = root.querySelector('[data-tl-hero]');
      const video = hero?.querySelector('video');
      if (!hero || !video || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      let current = 0;
      let target = 0;
      let frame = 0;

      const tick = () => {
        if (!Number.isFinite(video.duration) || video.duration <= 0) {
          frame = 0;
          return;
        }

        current += (target - current) * 0.16;
        if (!video.seeking && Math.abs(video.currentTime - current) > 0.01) {
          try {
            video.currentTime = current;
          } catch (error) {
            frame = 0;
            return;
          }
        }

        if (Math.abs(target - current) > 0.002) {
          frame = window.requestAnimationFrame(tick);
        } else {
          frame = 0;
        }
      };

      const updateTarget = () => {
        const rect = hero.getBoundingClientRect();
        const distance = Math.max(1, rect.height - window.innerHeight);
        const progress = Math.min(1, Math.max(0, -rect.top / distance));
        if (Number.isFinite(video.duration) && video.duration > 0) {
          target = progress * video.duration * 0.96;
          if (!frame) frame = window.requestAnimationFrame(tick);
        }
      };

      video.pause();
      video.muted = true;
      video.addEventListener('loadedmetadata', updateTarget);
      window.addEventListener('scroll', updateTarget, { passive: true });
      window.addEventListener('resize', updateTarget);
      updateTarget();

      root.tlCleanup = () => {
        video.removeEventListener('loadedmetadata', updateTarget);
        window.removeEventListener('scroll', updateTarget);
        window.removeEventListener('resize', updateTarget);
        if (frame) window.cancelAnimationFrame(frame);
      };
    };

    document.querySelectorAll('[data-tl-home]').forEach(initHome);
    document.addEventListener('shopify:section:load', (event) => initHome(event.target.querySelector('[data-tl-home]')));
    document.addEventListener('shopify:section:unload', (event) => event.target.querySelector('[data-tl-home]')?.tlCleanup?.());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joya_productos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-jewelry-product')) {
    class TlJewelryProduct extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.controller = new AbortController();
        this.signal = this.controller.signal;
        this.productDataNode = this.querySelector('[data-product-json]');
        this.productData = this.productDataNode ? JSON.parse(this.productDataNode.textContent) : { variants: [] };
        this.form = this.querySelector('[data-product-form]');
        this.quantity = 1;
        this.galleryItems = Array.from(this.querySelectorAll('[data-gallery-media]'));
        this.galleryDots = Array.from(this.querySelectorAll('[data-gallery-dot]'));
        this.galleryIndex = Math.max(0, this.galleryItems.findIndex((item) => item.classList.contains('is-active')));
        this.currentVariant = null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.setupGallery();
        this.setupOptions();
        this.setupQuantity();
        this.setupForm();
        this.setupSticky();
        this.setupAccordions();
        this.selectInitialVariant();
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        if (this.stickyObserver) this.stickyObserver.disconnect();
        this.initialized = false;
      }

      formatMoney(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents, this.dataset.moneyFormat);
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(cents / 100);
        } catch (error) {
          return (cents / 100).toFixed(2);
        }
      }

      setupGallery() {
        const rail = this.querySelector('[data-gallery-rail]');
        this.galleryDots.forEach((dot) => dot.addEventListener('click', () => this.showMedia(Number(dot.dataset.mediaIndex), true), { signal: this.signal }));
        if (!rail) return;
        let frame = null;
        rail.addEventListener('scroll', () => {
          if (frame) cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            if (!rail.clientWidth) return;
            this.setGalleryIndex(Math.round(rail.scrollLeft / rail.clientWidth));
          });
        }, { passive: true, signal: this.signal });
      }

      showMedia(index, animate) {
        if (!this.galleryItems.length) return;
        const next = Math.max(0, Math.min(this.galleryItems.length - 1, index));
        const item = this.galleryItems[next];
        item.scrollIntoView({ behavior: animate && !this.reducedMotion ? 'smooth' : 'auto', block: 'nearest', inline: 'start' });
        this.setGalleryIndex(next);
      }

      setGalleryIndex(index) {
        if (index < 0 || index >= this.galleryItems.length) return;
        this.galleryIndex = index;
        this.galleryItems.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
        this.galleryDots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });
      }

      setupOptions() {
        this.optionGroups = Array.from(this.querySelectorAll('[data-option-group]'));
        this.optionGroups.forEach((group) => {
          group.querySelectorAll('input[type="radio"]').forEach((input) => input.addEventListener('change', () => {
            group.querySelectorAll('label').forEach((label) => label.classList.toggle('is-selected', label.contains(input)));
            this.selectVariantFromOptions();
          }, { signal: this.signal }));
        });
      }

      selectInitialVariant() {
        if (!this.form) return;
        const id = Number(this.form.querySelector('[data-variant-id]')?.value);
        this.currentVariant = this.productData.variants.find((variant) => variant.id === id) || this.productData.variants[0] || null;
        this.renderProduct();
      }

      selectVariantFromOptions() {
        const options = this.optionGroups.map((group) => group.querySelector('input:checked')?.value || '');
        this.currentVariant = this.productData.variants.find((variant) => options.every((value, index) => variant['option' + (index + 1)] === value)) || null;
        this.renderProduct();
        if (this.currentVariant) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', this.currentVariant.id);
          window.history.replaceState({}, '', url);
        }
      }

      setupQuantity() {
        const minus = this.querySelector('[data-quantity-minus]');
        const plus = this.querySelector('[data-quantity-plus]');
        if (minus) minus.addEventListener('click', () => this.setQuantity(this.quantity - 1), { signal: this.signal });
        if (plus) plus.addEventListener('click', () => this.setQuantity(this.quantity + 1), { signal: this.signal });
      }

      setQuantity(next) {
        this.quantity = Math.max(1, Math.min(99, Number(next) || 1));
        const input = this.form?.querySelector('[data-quantity-input]');
        const output = this.querySelector('[data-quantity-output]');
        if (input) input.value = this.quantity;
        if (output) output.textContent = this.quantity;
      }

      renderProduct() {
        if (!this.form) return;
        const variantInput = this.form.querySelector('[data-variant-id]');
        const addButton = this.form.querySelector('[data-add-button]');
        const addLabel = this.form.querySelector('[data-add-label]');
        const stickyButton = this.querySelector('[data-sticky-submit]');
        if (!this.currentVariant) {
          if (variantInput) variantInput.value = '';
          if (addButton) addButton.disabled = true;
          if (stickyButton) stickyButton.disabled = true;
          if (addLabel) addLabel.textContent = 'Combinación no disponible';
          return;
        }

        if (variantInput) variantInput.value = this.currentVariant.id;
        const available = Boolean(this.currentVariant.available);
        if (addButton) addButton.disabled = !available;
        if (stickyButton) stickyButton.disabled = !available;
        if (addLabel) addLabel.textContent = available ? 'Agregar al carrito' : 'Agotado';

        const price = this.querySelector('[data-product-price]');
        const stickyPrice = this.querySelector('[data-sticky-price]');
        const compare = this.querySelector('[data-compare-price]');
        const badge = this.querySelector('[data-discount-badge]');
        if (price) price.textContent = this.formatMoney(this.currentVariant.price);
        if (stickyPrice) stickyPrice.textContent = this.formatMoney(this.currentVariant.price);
        if (compare) {
          compare.textContent = this.formatMoney(this.currentVariant.compareAt);
          compare.hidden = this.currentVariant.compareAt <= this.currentVariant.price;
        }
        if (badge) {
          const discount = this.currentVariant.compareAt > this.currentVariant.price ? Math.round((this.currentVariant.compareAt - this.currentVariant.price) * 100 / this.currentVariant.compareAt) : 0;
          badge.textContent = '-' + discount + '%';
          badge.hidden = discount === 0;
        }
        if (this.currentVariant.mediaId) {
          const mediaIndex = this.galleryItems.findIndex((item) => Number(item.dataset.mediaId) === this.currentVariant.mediaId);
          if (mediaIndex >= 0) this.showMedia(mediaIndex, true);
        }
      }

      setupForm() {
        if (!this.form) return;
        this.form.addEventListener('submit', (event) => this.submitForm(event), { signal: this.signal });
      }

      async submitForm(event) {
        event.preventDefault();
        const button = this.form.querySelector('[data-add-button]');
        const label = this.form.querySelector('[data-add-label]');
        const error = this.form.querySelector('[data-form-error]');
        if (button) button.disabled = true;
        if (error) error.hidden = true;
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(this.form)
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'No se pudo agregar al carrito.');
          if (button) button.classList.add('is-success');
          if (label) label.textContent = 'Agregado ✓';
          await this.updateCartCount();
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { source: 'tl-jewelry-product', item: result } }));
          window.setTimeout(() => {
            if (button) button.classList.remove('is-success');
            this.renderProduct();
          }, 1600);
        } catch (submitError) {
          if (error) {
            error.textContent = submitError.message;
            error.hidden = false;
          }
          this.renderProduct();
        }
      }

      async updateCartCount() {
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const cart = await response.json();
          this.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
        } catch (error) {}
      }

      setupSticky() {
        const sentinel = this.querySelector('[data-buy-sentinel]');
        const bar = this.querySelector('[data-sticky-bar]');
        const submit = this.querySelector('[data-sticky-submit]');
        if (!sentinel || !bar) return;
        this.stickyObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        }, { threshold: 0 });
        this.stickyObserver.observe(sentinel);
        if (submit) submit.addEventListener('click', () => this.form?.requestSubmit(), { signal: this.signal });
      }

      setupAccordions() {
        this.querySelectorAll('.tljp-accordions details').forEach((details) => details.addEventListener('toggle', () => {
          if (!details.open) return;
          this.querySelectorAll('.tljp-accordions details').forEach((item) => { if (item !== details) item.open = false; });
        }, { signal: this.signal }));
      }
    }

    customElements.define('tl-jewelry-product', TlJewelryProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-cafe-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-cafe-home')) {
    class TlCafeHome extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.signal = this.controller.signal;
        this.shell = this.querySelector('[data-coffee-shell]');
        this.tabs = Array.from(this.querySelectorAll('[data-coffee-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-coffee-panel]'));
        this.slides = Array.from(this.querySelectorAll('[data-coffee-slide]'));
        this.stage = this.querySelector('[data-coffee-stage]');
        this.currentLabel = this.querySelector('[data-coffee-current]');
        this.strengthLabel = this.querySelector('[data-coffee-strength]');
        this.index = 0;
        this.pointerStart = null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.select(Number(tab.dataset.index), true), { signal: this.signal });
          tab.addEventListener('keydown', (event) => this.onTabKeydown(event), { signal: this.signal });
        });

        const previous = this.querySelector('[data-coffee-prev]');
        const next = this.querySelector('[data-coffee-next]');
        if (previous) previous.addEventListener('click', () => this.select(this.index - 1, true), { signal: this.signal });
        if (next) next.addEventListener('click', () => this.select(this.index + 1, true), { signal: this.signal });

        if (this.stage) {
          this.stage.addEventListener('pointerdown', (event) => {
            if (event.target.closest('button')) return;
            this.pointerStart = event.clientX;
            try { this.stage.setPointerCapture(event.pointerId); } catch (error) {}
          }, { signal: this.signal });
          this.stage.addEventListener('pointerup', (event) => {
            if (this.pointerStart === null) return;
            const distance = event.clientX - this.pointerStart;
            this.pointerStart = null;
            if (Math.abs(distance) < 44) return;
            this.select(this.index + (distance < 0 ? 1 : -1), true);
          }, { signal: this.signal });
          this.stage.addEventListener('pointercancel', () => { this.pointerStart = null; }, { signal: this.signal });
        }

        this.querySelectorAll('[data-variant-select]').forEach((select) => {
          select.addEventListener('change', () => this.updateVariant(select), { signal: this.signal });
        });

        this.addEventListener('shopify:block:select', (event) => {
          const panel = event.target.closest('[data-coffee-panel]');
          if (panel) this.select(Number(panel.dataset.index), false);
        }, { signal: this.signal });

        this.setupReveal();
        this.setupParallax();
        this.render();
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        if (this.revealObserver) this.revealObserver.disconnect();
        if (this.parallaxFrame) cancelAnimationFrame(this.parallaxFrame);
      }

      select(nextIndex, animate) {
        const count = this.panels.length;
        if (!count) return;
        const normalized = ((nextIndex % count) + count) % count;
        if (normalized === this.index && this.panels[normalized] && !this.panels[normalized].hidden) return;
        this.index = normalized;
        const update = () => this.render();
        if (animate && !this.reducedMotion && document.startViewTransition) {
          try {
            document.startViewTransition(update);
          } catch (error) {
            update();
          }
        } else {
          update();
        }
      }

      render() {
        const panel = this.panels[this.index];
        if (!panel) return;
        if (this.shell) {
          this.shell.style.setProperty('--tlc-coffee-bg', panel.dataset.background || '#0854ec');
          this.shell.style.setProperty('--tlc-coffee-ink', panel.dataset.ink || '#f7f0e7');
        }
        if (this.strengthLabel) this.strengthLabel.textContent = panel.dataset.strength || '';
        if (this.currentLabel) this.currentLabel.textContent = String(this.index + 1).padStart(2, '0');

        this.tabs.forEach((tab, index) => {
          const active = index === this.index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });

        this.panels.forEach((item, index) => {
          item.hidden = index !== this.index;
        });

        const count = this.slides.length;
        this.slides.forEach((slide, index) => {
          let offset = index - this.index;
          if (offset > count / 2) offset -= count;
          if (offset < -count / 2) offset += count;
          const active = offset === 0;
          slide.style.transform = active
            ? 'translateX(-50%) translateY(0) scale(1)'
            : 'translateX(calc(-50% + ' + (offset * 132) + '%)) translateY(-8%) scale(0.72)';
          slide.style.opacity = active ? '1' : (Math.abs(offset) === 1 ? '0.82' : '0');
          slide.style.filter = active ? 'blur(0)' : 'blur(3px)';
          slide.style.zIndex = active ? '4' : '2';
          slide.setAttribute('aria-hidden', String(!active));
        });
      }

      onTabKeydown(event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = this.index;
        if (event.key === 'ArrowLeft') nextIndex -= 1;
        if (event.key === 'ArrowRight') nextIndex += 1;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        this.select(nextIndex, true);
        this.tabs[this.index].focus();
      }

      updateVariant(select) {
        const option = select.options[select.selectedIndex];
        const scope = select.closest('.tlc-product-panel, .tlc-starter__copy');
        if (!option || !scope) return;
        const price = scope.querySelector('[data-price]');
        const caption = scope.querySelector('.tlc-variant-caption');
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (caption) caption.textContent = option.textContent.replace(' — Agotado', '').trim();
      }

      setupReveal() {
        const items = this.querySelectorAll('[data-reveal]');
        if (!items.length || this.reducedMotion || !('IntersectionObserver' in window)) {
          items.forEach((item) => item.classList.add('is-visible'));
          return;
        }
        this.revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const siblings = Array.from(entry.target.parentElement.children);
            const delay = Math.max(0, siblings.indexOf(entry.target)) * 90;
            window.setTimeout(() => entry.target.classList.add('is-visible'), delay);
            this.revealObserver.unobserve(entry.target);
          });
        }, { threshold: 0.2 });
        items.forEach((item) => this.revealObserver.observe(item));
      }

      setupParallax() {
        this.parallaxItems = Array.from(this.querySelectorAll('[data-parallax]'));
        if (!this.parallaxItems.length || this.reducedMotion) return;
        const update = () => {
          const viewportHeight = window.innerHeight || 800;
          this.parallaxItems.forEach((item) => {
            const rect = item.getBoundingClientRect();
            const progress = (rect.top + rect.height / 2 - viewportHeight / 2) / viewportHeight;
            item.style.transform = 'translate3d(0,' + (-progress * 28).toFixed(1) + 'px,0)';
          });
          this.parallaxFrame = null;
        };
        const requestUpdate = () => {
          if (!this.parallaxFrame) this.parallaxFrame = requestAnimationFrame(update);
        };
        window.addEventListener('scroll', requestUpdate, { passive: true, signal: this.signal });
        window.addEventListener('resize', requestUpdate, { passive: true, signal: this.signal });
        requestUpdate();
      }
    }

    customElements.define('tl-cafe-home', TlCafeHome);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-cafe-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-cafe-product')) {
    class TlCafeProduct extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.signal = this.controller.signal;
        this.productDataNode = this.querySelector('[data-product-json]');
        this.productData = this.productDataNode ? JSON.parse(this.productDataNode.textContent) : { variants: [] };
        this.mainForm = this.querySelector('.tlp-form[data-product-form]');
        this.currentVariant = this.productData.variants[0] || null;
        this.currentPlanId = null;
        this.quantity = 1;
        this.galleryIndex = 0;
        this.pointerStart = null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.setupGallery();
        this.setupOptions();
        this.setupPurchaseOptions();
        this.setupQuantity();
        this.setupGift();
        this.setupForms();
        this.setupSticky();
        this.setupEditor();
        this.selectInitialVariant();
        this.updateCartState();
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        if (this.stickyObserver) this.stickyObserver.disconnect();
      }

      formatMoney(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents, this.dataset.moneyFormat);
        }
        const currency = this.dataset.currency || 'USD';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency, maximumFractionDigits: 2 }).format(cents / 100);
        } catch (error) {
          return (cents / 100).toFixed(2);
        }
      }

      setupGallery() {
        this.galleryItems = Array.from(this.querySelectorAll('[data-gallery-media]'));
        this.galleryThumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
        const active = this.galleryItems.findIndex((item) => item.classList.contains('is-active'));
        this.galleryIndex = active < 0 ? 0 : active;
        this.galleryThumbs.forEach((thumb) => thumb.addEventListener('click', () => this.showMedia(Number(thumb.dataset.mediaIndex), true), { signal: this.signal }));
        const previous = this.querySelector('[data-gallery-prev]');
        const next = this.querySelector('[data-gallery-next]');
        if (previous) previous.addEventListener('click', () => this.showMedia(this.galleryIndex - 1, true), { signal: this.signal });
        if (next) next.addEventListener('click', () => this.showMedia(this.galleryIndex + 1, true), { signal: this.signal });
        const stage = this.querySelector('[data-gallery-stage]');
        if (stage) {
          stage.addEventListener('pointerdown', (event) => {
            if (event.target.closest('button, video, iframe, model-viewer')) return;
            this.pointerStart = event.clientX;
          }, { signal: this.signal });
          stage.addEventListener('pointerup', (event) => {
            if (this.pointerStart === null) return;
            const distance = event.clientX - this.pointerStart;
            this.pointerStart = null;
            if (Math.abs(distance) > 42) this.showMedia(this.galleryIndex + (distance < 0 ? 1 : -1), true);
          }, { signal: this.signal });
          stage.addEventListener('pointercancel', () => { this.pointerStart = null; }, { signal: this.signal });
        }
      }

      showMedia(nextIndex, animate) {
        if (!this.galleryItems.length) return;
        this.galleryIndex = ((nextIndex % this.galleryItems.length) + this.galleryItems.length) % this.galleryItems.length;
        const update = () => {
          this.galleryItems.forEach((item, index) => {
            const active = index === this.galleryIndex;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-hidden', String(!active));
            const video = item.querySelector('video');
            if (!active && video) video.pause();
          });
          this.galleryThumbs.forEach((thumb, index) => {
            const active = index === this.galleryIndex;
            thumb.classList.toggle('is-active', active);
            thumb.setAttribute('aria-current', String(active));
          });
          this.querySelectorAll('.tlp-gallery__dots span').forEach((dot, index) => dot.classList.toggle('is-active', index === this.galleryIndex));
        };
        if (animate && !this.reducedMotion && document.startViewTransition) {
          try { document.startViewTransition(update); } catch (error) { update(); }
        } else {
          update();
        }
      }

      setupOptions() {
        this.optionGroups = Array.from(this.querySelectorAll('[data-option-group]'));
        this.optionGroups.forEach((group) => {
          group.querySelectorAll('input[type="radio"]').forEach((input) => {
            input.addEventListener('change', () => {
              group.querySelectorAll('.tlp-chip').forEach((label) => label.classList.toggle('is-selected', label.contains(input)));
              this.selectVariantFromOptions();
            }, { signal: this.signal });
          });
        });
      }

      selectInitialVariant() {
        if (!this.mainForm) return;
        const id = Number(this.mainForm.querySelector('[data-variant-id]')?.value);
        const selected = this.productData.variants.find((variant) => variant.id === id);
        if (selected) this.currentVariant = selected;
        this.renderProduct();
      }

      selectVariantFromOptions() {
        const selectedOptions = this.optionGroups.map((group) => group.querySelector('input:checked')?.value || '');
        const variant = this.productData.variants.find((item) => selectedOptions.every((value, index) => item['option' + (index + 1)] === value));
        this.currentVariant = variant || null;
        this.renderProduct();
        if (variant) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      }

      setupPurchaseOptions() {
        this.planInputs = Array.from(this.querySelectorAll('[data-selling-plan]'));
        this.planInputs.forEach((input) => input.addEventListener('change', () => {
          this.currentPlanId = input.value ? Number(input.value) : null;
          this.querySelectorAll('.tlp-plan-card').forEach((card) => card.classList.toggle('is-selected', card.contains(input)));
          this.renderProduct();
        }, { signal: this.signal }));
      }

      setupQuantity() {
        this.querySelectorAll('[data-quantity-choice]').forEach((input) => input.addEventListener('change', () => {
          this.quantity = Math.max(1, Number(input.value) || 1);
          this.querySelectorAll('.tlp-quantity__card').forEach((card) => card.classList.toggle('is-selected', card.contains(input)));
          const quantityInput = this.mainForm?.querySelector('[data-quantity-input]');
          if (quantityInput) quantityInput.value = this.quantity;
          this.renderProduct();
        }, { signal: this.signal }));
      }

      setupGift() {
        const toggle = this.querySelector('[data-gift-toggle]');
        const message = this.querySelector('[data-gift-message]');
        if (!toggle || !message) return;
        toggle.addEventListener('change', () => {
          toggle.closest('.tlp-gift').classList.toggle('is-open', toggle.checked);
          message.disabled = !toggle.checked;
          if (toggle.checked) message.focus();
        }, { signal: this.signal });
      }

      renderProduct() {
        if (!this.mainForm) return;
        const variantInput = this.mainForm.querySelector('[data-variant-id]');
        const addButton = this.mainForm.querySelector('[data-add-button]');
        const addLabel = this.mainForm.querySelector('[data-add-label]');
        const priceNode = this.querySelector('[data-product-price]');
        const compareNode = this.querySelector('[data-compare-price]');
        const captionNode = this.querySelector('[data-price-caption]');
        const stickyPrice = this.querySelector('[data-sticky-price]');
        const stickyCaption = this.querySelector('[data-sticky-caption]');
        const stickySubmit = this.querySelector('[data-sticky-submit]');

        if (!this.currentVariant) {
          if (variantInput) variantInput.value = '';
          if (addButton) addButton.disabled = true;
          if (addLabel) addLabel.textContent = 'Combinación no disponible';
          if (stickySubmit) stickySubmit.disabled = true;
          return;
        }

        if (variantInput) variantInput.value = this.currentVariant.id;
        const availablePlanIds = new Set(this.currentVariant.plans.map((plan) => plan.id));
        this.planInputs?.forEach((input) => {
          if (!input.value) return;
          const available = availablePlanIds.has(Number(input.value));
          input.disabled = !available;
          const card = input.closest('[data-plan-card]');
          const allocation = this.currentVariant.plans.find((plan) => plan.id === Number(input.value));
          const planPrice = card?.querySelector('[data-plan-price]');
          if (planPrice) planPrice.textContent = allocation ? this.formatMoney(allocation.price) : 'No disponible';
        });
        const oncePrice = this.querySelector('[data-once-price]');
        if (oncePrice) oncePrice.textContent = this.formatMoney(this.currentVariant.price);

        if (this.currentPlanId && !availablePlanIds.has(this.currentPlanId)) {
          this.currentPlanId = null;
          const once = this.planInputs.find((input) => !input.value);
          if (once) {
            once.checked = true;
            this.querySelectorAll('.tlp-plan-card').forEach((card) => card.classList.toggle('is-selected', card.contains(once)));
          }
        }

        let unitPrice = this.currentVariant.price;
        let unitCompare = this.currentVariant.compareAt || 0;
        const selectedAllocation = this.currentPlanId ? this.currentVariant.plans.find((plan) => plan.id === this.currentPlanId) : null;
        if (selectedAllocation) {
          unitPrice = selectedAllocation.price;
          unitCompare = selectedAllocation.compareAt || this.currentVariant.price;
        }
        const total = unitPrice * this.quantity;
        const compareTotal = unitCompare * this.quantity;
        if (priceNode) priceNode.textContent = this.formatMoney(total);
        if (compareNode) {
          compareNode.textContent = this.formatMoney(compareTotal);
          compareNode.hidden = compareTotal <= total;
        }
        const saveBadge = this.querySelector('[data-save-badge]');
        if (saveBadge) {
          saveBadge.hidden = compareTotal <= total;
          if (compareTotal > total) saveBadge.textContent = 'Ahorrás ' + this.formatMoney(compareTotal - total);
        }
        if (captionNode) captionNode.textContent = this.formatMoney(unitPrice) + ' por bolsa' + (selectedAllocation ? ' · suscripción' : ' · pago único');
        if (stickyPrice) stickyPrice.textContent = this.formatMoney(total);
        if (stickyCaption) stickyCaption.textContent = this.currentVariant.title + ' · ' + this.quantity + (this.quantity === 1 ? ' bolsa' : ' bolsas');

        const isAvailable = Boolean(this.currentVariant.available);
        if (addButton) addButton.disabled = !isAvailable;
        if (addLabel) addLabel.textContent = isAvailable ? (selectedAllocation ? 'Suscribirme' : 'Agregar al carrito') : 'Agotado';
        if (stickySubmit) stickySubmit.disabled = !isAvailable;

        let sellingPlanInput = this.mainForm.querySelector('input[name="selling_plan"]');
        if (selectedAllocation) {
          if (!sellingPlanInput) {
            sellingPlanInput = document.createElement('input');
            sellingPlanInput.type = 'hidden';
            sellingPlanInput.name = 'selling_plan';
            this.mainForm.appendChild(sellingPlanInput);
          }
          sellingPlanInput.value = selectedAllocation.id;
        } else if (sellingPlanInput) {
          sellingPlanInput.remove();
        }

        if (this.currentVariant.mediaId) {
          const mediaIndex = this.galleryItems.findIndex((item) => Number(item.dataset.mediaId) === this.currentVariant.mediaId);
          if (mediaIndex >= 0) this.showMedia(mediaIndex, true);
        }
        this.updateShipping(total);
      }

      updateShipping(subtotal) {
        const threshold = Number(this.dataset.freeShipping || 0);
        const message = this.querySelector('[data-shipping-message]');
        const progress = this.querySelector('[data-shipping-progress]');
        if (!threshold || !message || !progress) return;
        const remaining = Math.max(0, threshold - subtotal);
        message.textContent = remaining === 0 ? '¡Tenés envío gratis! 🎉' : 'Te faltan ' + this.formatMoney(remaining) + ' para envío gratis';
        progress.style.width = Math.max(4, Math.min(100, subtotal / threshold * 100)) + '%';
      }

      setupForms() {
        this.querySelectorAll('[data-product-form]').forEach((form) => form.addEventListener('submit', (event) => this.submitForm(event), { signal: this.signal }));
      }

      async submitForm(event) {
        event.preventDefault();
        const form = event.currentTarget;
        const button = form.querySelector('button[type="submit"]');
        const label = button?.querySelector('[data-add-label]');
        const error = form.querySelector('[data-form-error]');
        const originalButtonText = button?.textContent;
        if (button) button.disabled = true;
        if (error) error.hidden = true;
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'No se pudo agregar al carrito.');
          if (button) button.classList.add('is-success');
          if (label) label.textContent = 'Agregado ✓';
          else if (button) button.textContent = 'Agregado ✓';
          await this.updateCartState();
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { source: 'tl-cafe-product', item: result } }));
          window.setTimeout(() => {
            if (button) {
              button.classList.remove('is-success');
              button.disabled = false;
            }
            if (form === this.mainForm) this.renderProduct();
            else if (button && originalButtonText) button.textContent = originalButtonText;
          }, 1600);
        } catch (submitError) {
          if (error) {
            error.textContent = submitError.message;
            error.hidden = false;
          }
          if (button) button.disabled = false;
        }
      }

      async updateCartState() {
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const cart = await response.json();
          this.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
        } catch (error) {}
      }

      setupSticky() {
        const sentinel = this.querySelector('[data-buy-sentinel]');
        const bar = this.querySelector('[data-sticky-bar]');
        const submit = this.querySelector('[data-sticky-submit]');
        if (!sentinel || !bar) return;
        this.stickyObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        }, { threshold: 0 });
        this.stickyObserver.observe(sentinel);
        if (submit) submit.addEventListener('click', () => this.mainForm?.requestSubmit(), { signal: this.signal });
      }

      setupEditor() {
        this.addEventListener('shopify:block:select', (event) => {
          event.target.scrollIntoView({ behavior: this.reducedMotion ? 'auto' : 'smooth', block: 'center' });
        }, { signal: this.signal });
      }
    }
    customElements.define('tl-cafe-product', TlCafeProduct);
  }

  } catch(e) { console.error(e); }
})();
})();
